<template>
  <div>
    <div>
      <div class="heightcontainer">
        <div class="nav-height pendigfiexd w-100 shadow">
          <nav
            class="navbar navbar-expand-lg navbar-expand-sm navbar-expand-md navbar-expand-xl navbar-fixed-top"
          >
            <div class="col d-flex">
              <div class="col-6 mr-auto mt-2 ml-2">
                <router-link to="/" tag="a">
                  <img src="../assets/Logo.svg" class="MainNewLogo img-fluid" alt="logo"/>
                </router-link>
              </div>
            </div>
          </nav>
        </div>
        <div class="sign-in-background">
          <div class="row no-gutters pt-5" v-if="!fetchingTermsAndConditions">
            <div class="col pt-5" v-if="content1">
              <quill-editor v-model="content1" :options="editorOption" class="quill1" disabled></quill-editor>
            </div>
            <div class="col text-center mt-5" v-else>
              <span class="fontsize30 proximanova black">No privacy and policies are available</span>
            </div>
          </div>
          <div class="row no-gutters pt-5" v-else>
            <div class="col d-flex flex-column text-center mt-5">
              <img src="../assets/pt_loading1.jpg" class="mx-auto" width="200px" alt="loading">
              <!-- <span class="fontsize30 proximanova black">Fetching please wait...</span> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import httpuserprofile from "@/js/http-userprofile.js";
import { bus } from "@/main.js";
import router from '../router';
export default {
  components: {},
  data() {
    return {
      content1 : '',
      editorOption: {
        theme: 'bubble'
      },
      privacyPolicy : null,
      fetchingTermsAndConditions : true,
    };
  },
  mounted() {
    this.getUserPrivacyPolicy()
  },
  methods: {
    getUserPrivacyPolicy() {
      this.fetchingTermsAndConditions = true;
      httpuserprofile.get('/userprofile/getPrivacyPolicy?userType=candidate')
      .then((response) => {
        console.log("privacyPolicy : ", response)
        this.fetchingTermsAndConditions = false;
        this.privacyPolicy = response.data
        if(this.privacyPolicy !== null || this.privacyPolicy !== undefined){
          this.content1 = this.privacyPolicy.privacyPolicy
        }
      })
      .catch((e) => {
        console.log(e)
        this.fetchingTermsAndConditions = false;
      })
    }
  }
};
</script>
<style scoped>
.quill1{
  width: 80%;
  margin: auto;
}
</style>
